import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Component from './component'
import { updateFilter } from '../../redux/modules/estateOverviewFilters'
import { sFilterChips } from '../../shared/selectors'

const WithData = connect(
  (state, props) => ({
    filterChips: sFilterChips(state, props.filters ? props.filters : false),
  }),
  dispatch => bindActionCreators({ updateFilter }, dispatch)
)(Component)

export default WithData
